<template>
  <div data-color="dark" class="js-header-panel ">
     <div class="c-page c-blog u-pad-x-w3of12 u-pad-x-w1of12@sm u-pad-t-ultra u-pad-t-ultra@sm ">
       <section   data-color="dark"  class="u-pad-t-xl    js-header-panel is-active "   >
         <div class="c-page__header o-wrapper--panel " :style="'transform:translateX(' + headerPageSize[2] + 'px) translateY('+headerPageSize[3]+'px) scale('+headerPageSize[4]+')'" >
           <svg id="#Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="1020 -720 3000 2000">
          <radialGradient id="a" cx="2775.218" cy="852.018" r="1496.996" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".3" fill="url(#a)" d="M1099.3-42.9c54.9 10.8 110.3 22.9 168.9 35.6 193.3 42.1 393.2 85.7 589.8 85.7 119.6 0 224.3-16.1 320.1-49.3 102.7-35.5 215.6-104.4 335.2-177.3 196.8-120 400.3-244.1 592.3-244.1 108.1 0 200.9 39.5 283.6 120.9 61.5 60.5 102.2 118.3 141.6 174.2 66.5 94.4 129.3 183.5 280.1 263.4 84.1 44.6 163.4 66.3 242.3 66.3 2.9 0 5.8 0 8.7-.1l11.6-.2-4-10.9c-10.3-27.5-21.4-55.3-33.2-82.6l-2.1-4.9-5.3-.1c-70.2-1.4-140.2-17.4-208-47.4-148.5-65.8-211.9-158-278.9-255.5-41-59.7-83.4-121.4-147.3-180.9-83.9-78.2-176.1-116.2-281.9-116.2-189 0-384 122.2-572.6 240.3-117 73.3-227.5 142.5-329.2 177.6-93.3 32.2-195.9 47.9-313.5 47.9-195.9 0-396.4-43.4-590.3-85.4-61.7-13.4-120.1-26-177.6-37.1-46.9-9-93.8-18.3-140.6-27.7l-5.4-1.1-3.1 4.5c-12.9 19-25.8 39-39.4 61l-6.2 10 11.5 2.4c50.9 10.6 101.9 21 152.9 31z"/>
          <radialGradient id="b" cx="2781.999" cy="650.838" r="1471.638" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".3" fill="url(#b)" d="M1833.7 510.7c2.3-1.7 310.6-199 478.6-199 60.7 0 121.9 11.5 181.9 34.3 141 53.4 236.8 159.9 338.3 272.7 107.3 119.2 218.3 242.5 386.4 294.6 77.9 24.2 161.4 36.4 248.2 36.4 200.7 0 424.7-62.8 704.9-197.7l4.9-2.4-.3-5.5c-1.3-25.8-3.3-52.8-5.9-80.3l-1.2-12.2-10.8 5.7C3960 761.7 3728.4 873 3493.5 873c-73.6 0-144.8-11.3-211.7-33.5-157.8-52.5-259.7-170.9-358.2-285.4-89.2-103.6-181.4-210.8-314.3-268-67.3-29-137-43.7-207.2-43.7-115.3 0-226.3 38.6-334.3 96 193.9-120.7 392-228.3 587.3-228.3 87.8 0 167.9 21.4 244.8 65.4 49.9 28.6 91.4 64.4 127 101.4l.1-.1s70.9 77.8 147.6 76.4l162.9-2.9c.4 0 59.3-.1 72.8-65.7l41.1-164.2c8.7-31.2-4.7-57-10.5-66.3-32.8-48.3-72.9-100.8-129.5-148.4-86.8-73-184.1-108.4-297.5-108.4-224.9 0-473.4 145.4-692.7 273.7-137.3 80.3-267 156.2-379.4 191.6-91.7 28.9-188.3 43-295.2 43-202.5 0-407.5-51.3-605.7-101-42.5-10.6-84.7-21.2-126.6-31.2-29.7-7.1-59.3-14.4-89-21.6l-6.8-1.7-2.7 6.5C804 184.7 792.7 214.1 782 244l-3 8.5 26.4 6.8c12.2 3.2 24.5 6.3 36.8 9.4 36 9.1 72.1 18.5 108.4 28 200 52.3 406.9 106.3 612.9 106.3 105.6 0 201.8-13.9 294.2-42.4 118.7-36.7 254-116.1 397.3-200.2 222.3-130.4 474.2-278.3 700.1-278.3 106.7 0 199 31.7 282.2 96.9 25.9 20.3 49.7 43.2 73.2 69.7 7.5 9.7 31.5 43.2 27.4 67.5l-16.6 99.9c-5.5 32.9-33.2 34.7-41.9 34.5l-2.7-.2-95.6-5.6c-6.5-.5-28.4-4.2-52-31.8l-.1.1c-38.6-41.7-76.9-74.3-118.4-100.4-82.1-51.6-169.2-76.7-266.4-76.7-235.1 0-476.3 148.6-709.4 292.4-150.8 92.9-293.2 180.7-422.3 220-88.2 26.8-178.7 39.9-276.7 39.9-204.5 0-409.8-59-609-116.2l-8.5-2.5-1.8 8.7c-5.7 27.7-10.8 56.3-15.2 84.8l-1.1 7.1 6.9 2c175.2 51.4 362 101.5 548.8 101.5 97.9 0 188.7-13.2 277.5-40.5 89.7-27.1 299.7-122.1 300.3-122.5z"/>
          <radialGradient id="c" cx="2775.218" cy="852.018" r="1496.996" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#8c8d8e"/>
            <stop offset=".442" stop-color="#e0e2df"/>
            <stop offset="1" stop-color="#a4a5a7"/>
          </radialGradient>
          <path opacity=".7" fill="url(#c)" d="M3759.4 380.8c-56.2-24.3-103.6-54.9-146-94.5-44.1-34.3-60.9-3-66.9 17.3-2.3 7.9-3.1 14.3-3.1 14.3l-20.6 95.1-2.2 10c-4.6 17.1-18.2 50.5-54.6 56l-112.6 17-.3-.3-32.7 4.9c-17.7 3-95.8 20.8-24.1 95 52.2 47.4 105.7 81.2 166.7 105.3 69.6 27.5 142.9 41.4 218 41.4 141.2 0 288.1-45.6 476.3-147.9l5-2.7-.8-5.6c-1.2-8.8-2.5-17.6-3.8-26.4l-1.8-11.4-10.2 5.4c-149.9 79.6-275.2 116.7-394.3 116.7-72.3 0-143.4-14.3-211.3-42.7-22.6-9.4-44.1-20.3-64.8-32.6-20-12.8 1.2-19.2 1.2-19.2l78.2-11.3s3.8 0 9.4-1.4c13.4-3.3 37.3-14.5 44.8-53.9l12.5-65.6c1.1-4.8 5.6-16.5 24.5-5l.1-.5c19 11 38.6 21.3 59.7 30.2 70.2 29.7 144.2 44.8 219.7 44.8 67.6 0 136.4-11.4 210.1-35l7.1-2.3-1.5-7.3c-4-18.7-8.2-37.3-12.8-55.8l-2-8-8 2c-126.8 31.6-246 22.8-358.9-26z"/>
        </svg>

         </div>
       </section>


    <section   data-color="dark"      class="u-relative   js-header-panel is-active"  >
      <header class="c-blog__header">
        <h1 class="t-h1 t-text--roman u-marg-b-xs u-color--gray"><router-link  :to="globalContent.nav.links[5].href" class="c__item__link__News3">< Back to Innovations</router-link></h1>
       </header>
       <div class="u-fit inspire-Custom-Container u-marg-x-auto u-marg-y-xs35 u-marg-y-sm@sm">
           <div class="u-fit-w">

                     <div class="t-text--md--bold  u-marg-y-md u-marg-l-sm  u-marg-r-sm t-text--md--bold@md u-relative">
                         <span class="t-h3  c-home__section__upcomingprogram_title" :class="{'u-color--gray-dark':post.blocks.color=='dark',' c-inspire-title--color':post.blocks.color!='dark'}" v-html="post.blocks.title" ></span>
                         <span  class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>
                       </div>

            </div>
             <div class="c-home__grain o-wrapper--panel u-zindex--2 u-fit u-pointer-none is-active"></div>
             <div class="c-home__section__fade u-relative u-zindex--3 u-fit-w">
                   <div class="c-team__content  u-marg-t-md  u-w2of2 " >
                       <section class="u-relative">
                         <div class="c-team__section-container u-relative   u-marg-x-sm ">
                             <div class="c-team__section"   v-for="(item, index)  in post.blocks.content">

                                     <div class="u-marg-x-auto "  style="flex-grow:2;"  v-if="item.type.value=='image'">
                                           <img  :src="item.content"  class="img-fluid" >
                                     </div>


                                     <div class="asidewoekshop c-workshop__link__description-container"  >
                                           <h4 class="t-text--sm  u-align-left  c-inspire-pcomingp---boxblue-workshop  u-color--brand-blue u-marg-t-sm " v-if="item.type.value=='title'"  v-html="item.content"></h4>
                                           <h4 class="t-text--xs t-text-lh--xl  u-align-left u-color--gray  u-pad-b-xl  c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm" v-if="item.type.value=='default'" v-html="item.content" ></h4>
                                           <div class="u-marg-x-auto "  v-for="(itemimgup ,indexc)  in item.contentImgUp"    v-if="item.type.isimageUP=='true'">
                                                 <img  :src="itemimgup.content.src"  class="img-fluid" ><h5 class="u-marg-x-auto u-color--gray">{{itemimgup.content.label}}</h5>
                                           </div>
                                           <ul v-if="item.type.isListbullet=='true'" class="u-color--gray" style="list-style-type: square;padding-left:18px;" >
                                             <li  v-for="(itema, indexa)  in item.contentbullet"><h4 class="t-text--xs  u-align-left u-color--gray   c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="itema.text" ></h4></li>
                                           </ul>
                                           <ul v-if="item.type.isListnumbers=='true'" class="u-color--gray" style="list-style-type: decimal;padding-left:18px;" >
                                             <li  v-for="(itemb, indexb)  in item.contentnumbers"><h4 class="t-text--xs  u-align-left u-color--gray   c-inspire-pcomingp---boxblue-blog__article__description u-marg-t-sm"  v-html="itemb.text" ></h4></li>
                                           </ul>
                                           <div class="u-marg-x-auto "  v-for="(itemimg ,indexc)  in item.contentImgDown"    v-if="item.type.isimagedown=='true'">
                                                 <img  :src="itemimg.content.src"  class="img-fluid" ><h5 class="u-marg-x-auto u-color--gray">{{itemimg.content.label}}</h5>
                                           </div>
                                     </div>


                             </div>
                         </div>
                       </section>
                   </div>
             </div>
               </div>
     </section>

     </div>
     <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
   </div>
</template>
<script>
import {format, compareAsc} from 'date-fns'
import AppFooter from  '../app-footer/index.vue'
import  AppSlicedText from '../app-sliced-text/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'

export default
{
          components:{
                                    "app-sliced-text":AppSlicedText,
                                    "app-footer":AppFooter,
                                    "app-scroll-object":AppScrollObject


                    },
                    props:
                    {
                        adminContent: {
                            type: Object,
                            default: function() {}
                        },
                        globalContent: {
                            type: Object,
                            default: function() {}
                        },
                        headerPageSize: {
                            type: Array,
                            default: function() {}
                        }
                    },
                  data: function() {
                      return {

                      }
                  },
                  computed:
                  {


                      computedPosts: function()
                      {
                                console.log("this.adminContent.en.posts_innovation[1].length"+this.adminContent.en.posts_innovation);
                                var t = null,n = this.adminContent.en.posts_innovation[1].length;
                                console.log("this.adminContent.en.posts_innovation[1].length"+this.adminContent.en.posts_innovation[1].length);
                                for (var e = 0;e < n; e += 1)
                                {
                                    var r = this.adminContent.en.posts_innovation[1][e];
                                    r.slug === this.$route.params.slug && (t = r)
                                }
                                  console.log(t);
                                return t
                        }//,
                      //computedCurrentPageIndex: function()
                      //{
                          //var t = 1;
                          //return this.$route.query.page && (t = this.adminContent.en.posts_innovation[this.$route.query.page] ? parseInt(this.$route.query.page, 10) : 0), t
                      //}
                  },

                  created: function()
                  {
                        this.post = this.computedPosts,
                        console.log("this.post = this.computedPost,"+this.post);
                        //this.post || this.$router.push("/marine-holdings/media-news"),
                        this.onResize = this.onResize.bind(this),

                        this.eventHub.$on("resize", this.onResize)
                  },
                  destroyed: function()
                  {

                      this.eventHub.$off("resize", this.onResize)
                  },
                  mounted: function()
                  {
                    //document.addEventListener('render-done', (e) => {   console.log(e)})
                    //this.$nextTick(() => {const event = new CustomEvent('render-done');  document.dispatchEvent(event);})
                      this.eventHub.$emit("page:ready"),
                      this.onResize()
                  },

                  methods:
                  {

                      onResize: function() {},
                      LinkResource(Linkurl)
                    {
                      window.open('https://www.facebook.com/sharer/sharer.php?u='+Linkurl,'facebook-share-dialog','width=626,height=436'); return false;
                    }
                  }
    }

</script>
<style  scoped>

</style>
